const $ = require('jquery');
module.exports = function () {
    // front-page functionality goes here

    /**
     * Point of attention in the fllowing code will be the rate limit of the providing services.
     */
    var widget_zoover = $('#zoover_widget'),
        rating_zoover = $('.rating-zoover');
    if (1 == widget_zoover.length && 1 == rating_zoover.length) {
        var check_zoover = setInterval(function () {
            if (0 != widget_zoover.find('.review-count').length) {
                clearInterval(check_zoover);
                var rating = widget_zoover.find('.review-data .review-details li:first-child .value').text();
                rating_zoover.find('.rating-grade').html(rating + '<sub>/10</sub>');
                var count = widget_zoover.find('.review-count .cta-link:first-child').text().match(/\d+/)[0];
                rating_zoover.find('.rating-text .count').text(count);
                rating_zoover.show();
            }
        }, 500);
    }

    var widget_tripadvisor = $('#tripadvisor_widget'),
        rating_tripadvisor = $('.rating-tripadvisor');
    if (1 == widget_tripadvisor.length && 1 == rating_tripadvisor.length) {
        var check_tripadvisor = setInterval(function () {
            if (0 != widget_tripadvisor.find('.cdsRating').length) {
                clearInterval(check_tripadvisor);
                var rating = widget_tripadvisor.find('.cdsRating img').attr('alt').match(/\d+/)[0];
                rating_tripadvisor.find('.rating-grade').html(rating + '<sub>/5</sub>');
                var count = widget_tripadvisor.find('.cdsRating span').text().match(/\d+(\.\d+)?/)[0];
                rating_tripadvisor.find('.rating-text .count').text(count);
                rating_tripadvisor.show();
            }
        }, 500);
    }

};